const PassosSchema = () => ({
  title: 'AgSUS Passo a passo',
  fieldsets: [
    {
      id: 'default',
      title: 'Conteúdo',
      fields: ['passos', 'disposicao', 'fundo'],
    },
  ],
  properties: {
    passos: {
      title: 'Passos',
      description:
        'Na ordem em que acontecem. O número de cada passo é posto sozinho.',
      widget: 'object_list',
      schema: {
        title: 'Passo',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['titulo', 'texto', 'link', 'rotuloLink'],
          },
        ],
        properties: {
          titulo: {
            title: 'Título',
            description: 'Opcional. Ex.: Inscrição',
          },
          texto: { title: 'Texto', widget: 'textarea' },
          link: {
            title: 'Link',
            description:
              'Opcional. Endereço de uma página do site ou completo.',
          },
          rotuloLink: {
            title: 'Texto do link',
            description: 'Vazio: "Saiba mais".',
          },
        },
        required: [],
      },
    },
    disposicao: {
      title: 'Disposição',
      description:
        'Lado a lado funciona até 5 passos; acima disso, e sempre no celular, os passos ficam em coluna.',
      choices: [
        ['horizontal', 'Lado a lado'],
        ['vertical', 'Em coluna'],
      ],
      default: 'horizontal',
    },
    fundo: {
      title: 'Fundo',
      choices: [
        ['creme', 'Faixa creme de ponta a ponta'],
        ['azul', 'Faixa azul com padronagem'],
        ['branco', 'Branco, sem faixa'],
      ],
      default: 'creme',
    },
  },
  required: [],
});

export default PassosSchema;
